import checkoutReducer from './reducers';

export default checkoutReducer;
